module.exports = __webpack_public_path__ + "static/media/maize-bag.2748fa14.PNG";